import React, { useEffect } from "react";

function ResourceContentListSection({ t }) {
  const scrollToSection = (sectionId) => {
    const section = document.getElementById(sectionId);
    if (section) {
      const offset = -200;
      const sectionPosition =
        section.getBoundingClientRect().top + window.pageYOffset;
      window.scrollTo({
        top: sectionPosition + offset,
        behavior: "smooth",
      });
    }
  };

  const handleContentItemClick = (sectionId) => {
    scrollToSection(sectionId);
  };

  const handleContentItemKeyPress = (event, sectionId) => {
    if (event.key === "Enter") {
      scrollToSection(sectionId);
    }
  };

  useEffect(() => {
    const header = document.getElementById("myHeader");
    if (!header) return;

    const sticky = header.offsetTop;

    const handleScroll = () => {
      if (window.pageYOffset > sticky) {
        header.classList.add("sticky");
      } else {
        header.classList.remove("sticky");
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <section className="resources-contents-container">
      <h2>{t.contents.header}</h2>
      <ul className="resources-contents-list">
        {t.contents.list.map((items, index) => (
          <li
            key={index}
            onClick={() => handleContentItemClick(items.id)}
            onKeyDown={(event) => handleContentItemKeyPress(event, items.id)}
            tabIndex="0"
          >
            {items.label}
          </li>
        ))}
      </ul>
    </section>
  );
}

export default ResourceContentListSection;
